import React from 'react'
import CoachSearchResultsLayout from '@layouts/coaches-search'
import withSearchComp from '@components/coaches-search/CoachResults/SearchParentComp'

function SearchPlaces(props) {
  return <CoachSearchResultsLayout {...props} />
}

const CoachesSearchPage = withSearchComp(SearchPlaces)

/**
 * Classic coach directory search. Offering-first program search lives at `/golf-lessons`.
 *
 * The marketplace layout is always on after the directory rollout.
 */

export default CoachesSearchPage
